import { gql } from "@apollo/client";

export const CREATE_ONE_TIME_ORDER = gql`
  mutation CreateOneTimeOrder(
    $order_id: uuid = ""
    $parking_id: uuid = ""
    $status: String = ""
    $phone: String!
    $plate: String = ""
  ) {
    insert_one_time_order_one(
      object: {
        order_id: $order_id
        parking_id: $parking_id
        status: $status
        plate: $plate
        phone: $phone
      }
    ) {
      id
      order_id
      parking_id
      status
      phone
      plate
    }
  }
`;

/**
 * This is less correct variable naming as it's value is object, not boolean
 *
 * @type {typeof import('api/gql/graphql').CheckHasActiveOrderQuery}
 * @deprecated
 */
export const CHECK_HAS_ACTIVE_ORDER = gql`
  query CheckHasActiveOrder(
    $phone: String = ""
    $plate: String = ""
    $parking_id: uuid = ""
  ) {
    one_time_order(
      where: {
        phone: { _eq: $phone }
        plate: { _eq: $plate }
        status: { _eq: "ACTIVE" }
        parking_id: { _eq: $parking_id }
        order: { deleted_at: { _is_null: true } }
      }
    ) {
      id
      order_id
      parking_id
      phone
      plate
      status
    }
    order(
      where: {
        valid_until: { _gte: "now()" }
        payment_status: { _eq: "success" }
        deleted_at: { _is_null: true }
        order_users: { phone: { _eq: $phone } }
        parking_id: { _eq: $parking_id }
      }
    ) {
      orderer {
        limit
      }
      one_time_orders_aggregate(where: { status: { _eq: "ACTIVE" } }) {
        aggregate {
          count
        }
      }
    }
  }
`;

/**
 * This is more correct variable naming than previous one "check"
 *
 * @type {typeof import('api/gql/graphql').CheckHasActiveOrderQuery}
 */
export const GET_ACTIVE_ORDER = CHECK_HAS_ACTIVE_ORDER;

export const GET_ACTIVE_ORDER_IF_ANY = gql`
  query GetActiveOrderIfAny($phone: String!) {
    one_time_order(
      where: {
        phone: { _eq: $phone }
        status: { _eq: "ACTIVE" }
        order: { deleted_at: { _is_null: true } }
      }
    ) {
      id
      order_id
      parking_id
      phone
      plate
      status
      parking {
        name
        longitude
        latitude
        in_use_count
        hourly_price
        full_address
        daily_price
        currency
        id
        monthly_price
        size
        gates_aggregate(
          where: { status: { _eq: "ENABLED" }, type: { _eq: "GATE" } }
        ) {
          aggregate {
            count
          }
        }
        gates(where: { is_exit: { _eq: true }, type: { _eq: "GATE" } }) {
          uid
          upass
          id
        }
        barriers: gates(where: { type: { _eq: "BARRIER" } }) {
          uid
          upass
          id
        }
      }
      order {
        valid_from
        payment_duration
        id
        payment_status
      }
    }
  }
`;

export const DISABLE_ONE_TIME_ORDER = gql`
  mutation DisableOneTimeOrder($parking_id: uuid = "", $plate: String = "") {
    update_one_time_order(
      where: { parking_id: { _eq: $parking_id }, plate: { _eq: $plate } }
      _set: { status: "INACTIVE" }
    ) {
      returning {
        id
        order_id
        parking_id
        phone
        plate
        status
      }
    }
  }
`;

export const TOGGLE_GATE = gql`
  mutation ToggleGate($uid: String = "", $upass: String = "") {
    openGate(uid: $uid, upass: $upass) {
      command
      object_id
      packet
      receiver_id
      value
    }
  }
`;
